<template>
	<div class="h5-table">
		<a-table :data-source="tableDatas" :pagination="false" bordered>
			<!-- 插槽写法 -->
			<a-table-column key="installCapcity" data-index="capacity">
				<template #title>
					<div class="cell-title">储能装机容量</div>
					<div class="cell-unit">kWh</div>
				</template>
			</a-table-column>
			<a-table-column-group>
				<template #title
					><div class="cell-title">固定策略</div></template
				>
				<a-table-column key="preDayIncome" data-index="preDayIncome">
					<template #title>
						<div style="min-width: 50px">
							<div class="cell-title">日均收益</div>
							<div class="cell-unit">元/天</div>
						</div>
					</template>
				</a-table-column>
				<a-table-column
					key="preUnitDayIncome"
					data-index="preUnitDayIncome"
				>
					<template #title>
						<div class="cell-title">单位容量日均收益</div>
						<div class="cell-unit">元/(天*kWh)</div>
					</template>
				</a-table-column>
			</a-table-column-group>
			<a-table-column-group>
				<template #title
					><div class="cell-title">智能策略</div></template
				>
				<a-table-column key="wiseDayIncome" data-index="wiseDayIncome">
					<template #title>
						<div style="min-width: 50px">
							<div class="cell-title">日均收益</div>
							<div class="cell-unit">元/天</div>
						</div>
					</template>
				</a-table-column>
				<a-table-column
					key="wiseUnitDayIncome"
					data-index="wiseUnitDayIncome"
				>
					<template #title>
						<div class="cell-title">单位容量日均收益</div>
						<div class="cell-unit">元/(天*kWh)</div>
					</template>
				</a-table-column>
			</a-table-column-group>
		</a-table>
	</div>
</template>

<script setup>
	import { defineProps, ref, watch } from "vue";
	import { toFixed } from "@/plugins/index.js";

	const tableDatas = ref([]);

	const props = defineProps({
		averageDatas: {
			type: Object,
			default: () => {
				return {};
			}
		}
	});

	// 处理表格数据
	const hanldeAverageData = () => {
		const { dayProfit, unitCapacityDayProfit } = props.averageDatas;

		console.log(dayProfit, unitCapacityDayProfit);

		let arr = new Array(dayProfit.length).fill({});
		console.log(arr);
		arr.forEach((row, index) => {
			const dayProfitRow = dayProfit[index];
			const unitCapacityDayProfitRow = unitCapacityDayProfit[index];
			arr[index] = {
				id: `table-${index}`,
				capacity: toFixed(dayProfitRow.capacity),

				preDayIncome: toFixed(dayProfitRow.prev, 2),
				preUnitDayIncome: toFixed(unitCapacityDayProfitRow.prev, 4),

				wiseDayIncome: toFixed(dayProfitRow.wise, 2),
				wiseUnitDayIncome: toFixed(unitCapacityDayProfitRow.wise, 4)
			};
		});
		tableDatas.value = arr;
	};

	watch(
		() => props.averageDatas,
		(newVal, oldVal) => {
			if (newVal && Object.keys(newVal).length > 0) {
				// 处理表格数据
				hanldeAverageData();
			}
		},
		{ immediate: true, deep: true }
	);
</script>

<style lang="less" scoped>
	.h5-table {
		margin: 24px 0px;
		.cell-title {
			opacity: 0.85;
			font-family: PingFangSC-Medium;
			font-weight: 600;
			font-size: 12px;
		}
		.cell-unit {
			opacity: 0.45;
			font-weight: 400;
			font-size: 12px;
			color: #000000;
		}
	}
	::v-deep .ant-table-cell {
		font-size: 12px;
		padding: 8px !important;
		text-align: center !important;
	}
</style>
